export const GET_ALL_SHOWS = 'GET_ALL_SHOWS';
export const CLEAR_ALL_SHOWS = 'CLEAR_ALL_SHOWS';
export const ADD_SHOW = 'ADD_SHOW';
export const EDIT_SHOW = 'EDIT_SHOW';
export const REVIVE_SHOW = 'REVIVE_SHOW';
export const DELETE_SHOW = 'DELETE_SHOW';
export const BOXOFFICE_ERROR = 'BOXOFFICE_ERROR';
export const CHANGE_TIMEZONE = 'CHANGE_TIMEZONE';
